var _path, _g, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPassword = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "icon-password_svg__a",
  width: 20,
  height: 20,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M0 0h20v20H0z",
  clipRule: "evenodd"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#icon-password_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#946952",
  fillRule: "evenodd",
  d: "M5.664 1.5C3.134 1.5 1.5 3.233 1.5 5.916v8.168c0 2.683 1.635 4.416 4.164 4.416h8.668c2.532 0 4.168-1.733 4.168-4.416V5.916c0-2.683-1.636-4.416-4.166-4.416zM14.332 20H5.664C2.276 20 0 17.622 0 14.084V5.916C0 2.378 2.276 0 5.664 0h8.67C17.723 0 20 2.378 20 5.916v8.168C20 17.622 17.723 20 14.332 20",
  clipRule: "evenodd"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#946952",
  fillRule: "evenodd",
  d: "M6.84 8.898a1.103 1.103 0 0 0-.003 2.204c.607 0 1.102-.494 1.102-1.102 0-.607-.494-1.1-1.1-1.102m-.003 3.704A2.605 2.605 0 0 1 4.235 10a2.605 2.605 0 0 1 2.602-2.602A2.605 2.605 0 0 1 9.44 10a2.605 2.605 0 0 1-2.602 2.602",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#946952",
  fillRule: "evenodd",
  d: "M15.01 12.602a.75.75 0 0 1-.75-.75v-1.103H8.69a.75.75 0 1 1 0-1.5h6.318a.75.75 0 0 1 .75.75v1.853a.75.75 0 0 1-.75.75",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#946952",
  fillRule: "evenodd",
  d: "M12.182 12.602a.75.75 0 0 1-.75-.75V9.999a.75.75 0 0 1 1.5 0v1.853a.75.75 0 0 1-.75.75",
  clipRule: "evenodd"
})));
export default SvgIconPassword;